import {utilHelper} from "../../_helpers";

const relativeUrl = '/api/dishDrinkPrice'

export const dishDrinkPriceService = {
    search,
    syncFirebase,
    saveItem,
    updateItem,
    deleteItem,
    priceExchange,
};

function search(offset, max, dataFilter) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search`, 'POST', { data: dataFilter, showAlert: false})
}

function syncFirebase() {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncFirebase`, 'GET',{})
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', {data:data});
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', {data:data});
}

function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE',{})
}

function priceExchange(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/priceExchange`, 'POST', { data: data, showAlert: true});
}
